import * as React from "react";
const SvgChevronLeft = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15.5253 18.9662L8.55835 12.0002L15.5253 5.0332", stroke: "#111111", strokeWidth: 1.5 }));
export default SvgChevronLeft;
